var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6082BB",
    d: "M19.192 16.855c3.04 0 4.998.536 5.982 1.695s1.247 3.04.711 5.71c-.535 2.67-1.607 4.822-3.126 5.981-1.52 1.16-3.927 1.757-7.142 1.757h-4.813l2.942-15.178zM0 47.387h7.853l1.87-9.662h6.79a23.8 23.8 0 0 0 7.317-.984 14.5 14.5 0 0 0 5.27-3.127 16.7 16.7 0 0 0 3.215-4.014 17.3 17.3 0 0 0 1.757-4.822c.8-4.287.175-7.677-1.871-9.996-2.047-2.319-5.446-3.575-9.996-3.575H7.053zM39.877 1.5h7.905l-1.871 9.662h6.965c4.392 0 7.414.8 9.11 2.319 1.694 1.52 2.142 4.014 1.519 7.413l-3.338 16.847h-7.905l3.083-15.977c.36-1.757.263-3.04-.36-3.75-.624-.712-1.933-.985-3.927-.985h-6.245l-4.058 20.712h-7.818zM80.79 16.855c3.04 0 4.998.536 5.982 1.695.983 1.16 1.247 3.04.711 5.71s-1.607 4.822-3.127 5.981c-1.52 1.16-3.926 1.757-7.141 1.757h-4.84l2.943-15.178zM61.598 47.387h7.852l1.871-9.662h6.781a23.8 23.8 0 0 0 7.317-.984 14.5 14.5 0 0 0 5.27-3.127 16.7 16.7 0 0 0 3.215-4.014 17.3 17.3 0 0 0 1.757-4.822c.799-4.287.175-7.677-1.871-9.996-2.047-2.319-5.446-3.575-9.996-3.575H68.651l-7.027 36.154z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/PHP.6a7338f9b09b8a8bd3398fd5d3096d67.svg";
export { ForwardRef as ReactComponent };